// Caps large sidebar badge counts to a bucket instead of an exact number, so a
// count doesn't need to be updated in realtime for every single increment/decrement
// once it's already well past the point where the exact value matters to the user.
export function formatBadgeCount(count) {
  const n = Number(count) || 0;
  if (n <= 99) return String(n);
  if (n <= 999) return "99+";
  if (n <= 9999) return "999+";
  return "9999+";
}
